import './button.css';
export default {
  "badge": "pf-v6-c-badge",
  "button": "pf-v6-c-button",
  "buttonCount": "pf-v6-c-button__count",
  "buttonHamburgerIcon": "pf-v6-c-button--hamburger-icon",
  "buttonHamburgerIconArrow": "pf-v6-c-button--hamburger-icon--arrow",
  "buttonHamburgerIconBottom": "pf-v6-c-button--hamburger-icon--bottom",
  "buttonHamburgerIconMiddle": "pf-v6-c-button--hamburger-icon--middle",
  "buttonHamburgerIconTop": "pf-v6-c-button--hamburger-icon--top",
  "buttonIcon": "pf-v6-c-button__icon",
  "buttonIconFavorite": "pf-v6-c-button__icon-favorite",
  "buttonIconFavorited": "pf-v6-c-button__icon-favorited",
  "buttonProgress": "pf-v6-c-button__progress",
  "buttonText": "pf-v6-c-button__text",
  "modifiers": {
    "primary": "pf-m-primary",
    "unread": "pf-m-unread",
    "secondary": "pf-m-secondary",
    "danger": "pf-m-danger",
    "tertiary": "pf-m-tertiary",
    "link": "pf-m-link",
    "inline": "pf-m-inline",
    "displayLg": "pf-m-display-lg",
    "warning": "pf-m-warning",
    "control": "pf-m-control",
    "stateful": "pf-m-stateful",
    "read": "pf-m-read",
    "attention": "pf-m-attention",
    "plain": "pf-m-plain",
    "noPadding": "pf-m-no-padding",
    "block": "pf-m-block",
    "small": "pf-m-small",
    "favorite": "pf-m-favorite",
    "favorited": "pf-m-favorited",
    "settings": "pf-m-settings",
    "hamburger": "pf-m-hamburger",
    "expand": "pf-m-expand",
    "collapse": "pf-m-collapse",
    "clicked": "pf-m-clicked",
    "disabled": "pf-m-disabled",
    "ariaDisabled": "pf-m-aria-disabled",
    "progress": "pf-m-progress",
    "inProgress": "pf-m-in-progress",
    "notify": "pf-m-notify",
    "start": "pf-m-start",
    "end": "pf-m-end"
  },
  "spinner": "pf-v6-c-spinner"
};